import { withStyles } from "@material-ui/core/styles";
import moment from "moment-timezone";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import Field from "../../components/schedule/Field";
import NoScheduleMessage from "../../components/schedule/NoScheduleMessage";
import defaultMatchTimes from "../../constants/DefaultMatchTimes";
import { getMatchDuration } from "../../util/GetMatchDuration";
import EditFieldContainer from "./EditFieldContainer";

const styles = (theme) => ({
  root: {
    height: "calc(100vh - 126px)",
    [theme.breakpoints.up("sm")]: {
      height: "calc(100vh - 134px)",
    },
    overflowY: "auto",
  },
});

class FieldsContainer extends Component {
  render() {
    let day = this.props.day;
    let matches = [];
    if (this.props.matchesTemp) {
      matches = this.props.matchesTemp;
    } else {
      matches = this.props.matches;
      let breaks = Object.keys(this.props.tournament.breaks || {}).map(
        (key, i) => {
          let tournamentBreak = this.props.tournament.breaks[key];
          tournamentBreak["id"] = key;
          tournamentBreak["isBreak"] = true;
          return tournamentBreak;
        }
      );
      matches = matches.concat(breaks);
    }

    let dividedPerPoule = {};
    if (dividedPerPoule["events"] === undefined) {
      dividedPerPoule["events"] = {};
    }
    let dividedRefs = {};
    let matchesPerField = {};
    Object.keys(this.props.tournament.fields || {}).forEach((fieldKey, i) => {
      let field = this.props.tournament.fields[fieldKey];
      field["id"] = fieldKey;
      let fieldMatches = matches
        .filter((match) => match.field === field.id && match.day === day)
        .sort((a, b) => {
          if (Number(a.numInField) > Number(b.numInField)) {
            return 1;
          } else if (Number(a.numInField) < Number(b.numInField)) {
            return -1;
          } else {
            return 0;
          }
        });
      let startTimestamp = field.startTime;
      if (day !== "0") {
        startTimestamp = field[day] || field.startTime;
      }
      let matchesWithTime = fieldMatches.map((match, i) => {
        const startTime = moment.unix(startTimestamp).format("HH:mm");
        const endTime = moment
          .unix(
            startTimestamp +
              getMatchDuration(
                this.props.tournament,
                this.props.poulesByKey,
                match
              ) *
                60
          )
          .format("HH:mm");
        let matchWithTime = match;
        if (match.isBreak) {
          startTimestamp += Number(match.duration || 0) * 60;
          if (match.isEvent) {
            (match.teams || []).forEach((t) => {
              if (dividedPerPoule["events"][t] === undefined) {
                dividedPerPoule["events"][t] = [];
              }
              dividedPerPoule["events"][t].push([startTime, endTime]);

              if (this.props.tournament.teamsAsRefs) {
                if (this.props.refereesByKey[t] !== undefined) {
                  if (dividedRefs[t] === undefined) {
                    dividedRefs[t] = [];
                  }
                  dividedRefs[t].push([startTime, endTime]);
                }
              }
            });
          }
        } else {
          startTimestamp +=
            getMatchDuration(
              this.props.tournament,
              this.props.poulesByKey,
              match
            ) * 60;
          startTimestamp +=
            (this.props.tournament.timeBetweenMatches !== undefined
              ? this.props.tournament.timeBetweenMatches
              : defaultMatchTimes.timeBetweenMatches) * 60;

          // =====
          if (dividedPerPoule["teams"] === undefined) {
            dividedPerPoule["teams"] = {};
          }
          const poule = this.props.poulesByKey[match.poule] || {};
          let pouleKeyName = poule.fase;
          if (poule.bracket) {
            let bracket = this.props.bracketsByKey[poule.bracket] || {};
            pouleKeyName =
              poule.bracketRound === bracket.size && !bracket.subBracketTo
                ? poule.fase
                : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
          }
          let team1 = this.props.teams.find(
            (t) =>
              t["poule" + pouleKeyName] === match.poule &&
              t["numInPoule" + pouleKeyName] === match.team1
          );
          let team2 = this.props.teams.find(
            (t) =>
              t["poule" + pouleKeyName] === match.poule &&
              t["numInPoule" + pouleKeyName] === match.team2
          );
          if (team1) {
            if (dividedPerPoule["teams"][team1.id] === undefined) {
              dividedPerPoule["teams"][team1.id] = [];
            }
            dividedPerPoule["teams"][team1.id].push([startTime, endTime]);

            matchWithTime["team1Id"] = team1.id;

            if (this.props.tournament.teamsAsRefs) {
              if (this.props.refereesByKey[team1.id] !== undefined) {
                if (dividedRefs[team1.id] === undefined) {
                  dividedRefs[team1.id] = [];
                }
                dividedRefs[team1.id].push([startTime, endTime]);
              }
            }
          }
          if (team2) {
            if (dividedPerPoule["teams"][team2.id] === undefined) {
              dividedPerPoule["teams"][team2.id] = [];
            }
            dividedPerPoule["teams"][team2.id].push([startTime, endTime]);

            matchWithTime["team2Id"] = team2.id;

            if (this.props.tournament.teamsAsRefs) {
              if (this.props.refereesByKey[team2.id] !== undefined) {
                if (dividedRefs[team2.id] === undefined) {
                  dividedRefs[team2.id] = [];
                }
                dividedRefs[team2.id].push([startTime, endTime]);
              }
            }
          }
          // =====
          if (dividedPerPoule[match.poule] === undefined) {
            dividedPerPoule[match.poule] = {};
          }
          if (dividedPerPoule[match.poule][match.team1] === undefined) {
            dividedPerPoule[match.poule][match.team1] = [];
          }
          if (dividedPerPoule[match.poule][match.team2] === undefined) {
            dividedPerPoule[match.poule][match.team2] = [];
          }
          dividedPerPoule[match.poule][match.team1].push([startTime, endTime]);
          dividedPerPoule[match.poule][match.team2].push([startTime, endTime]);
          if (match.referee) {
            if (dividedRefs[match.referee] === undefined) {
              dividedRefs[match.referee] = [];
            }
            dividedRefs[match.referee].push([startTime, endTime]);

            if (this.props.tournament.teamsAsRefs) {
              if (this.props.teamsByKey[match.referee] !== undefined) {
                if (dividedPerPoule["events"][match.referee] === undefined) {
                  dividedPerPoule["events"][match.referee] = [];
                }
                dividedPerPoule["events"][match.referee].push([
                  startTime,
                  endTime,
                ]);
              }
            }
          }
          if (match.referee2) {
            if (dividedRefs[match.referee2] === undefined) {
              dividedRefs[match.referee2] = [];
            }
            dividedRefs[match.referee2].push([startTime, endTime]);

            if (this.props.tournament.teamsAsRefs) {
              if (this.props.teamsByKey[match.referee2] !== undefined) {
                if (dividedPerPoule["events"][match.referee2] === undefined) {
                  dividedPerPoule["events"][match.referee2] = [];
                }
                dividedPerPoule["events"][match.referee2].push([
                  startTime,
                  endTime,
                ]);
              }
            }
          }
          if (match.referee3) {
            if (dividedRefs[match.referee3] === undefined) {
              dividedRefs[match.referee3] = [];
            }
            dividedRefs[match.referee3].push([startTime, endTime]);

            if (this.props.tournament.teamsAsRefs) {
              if (this.props.teamsByKey[match.referee3] !== undefined) {
                if (dividedPerPoule["events"][match.referee3] === undefined) {
                  dividedPerPoule["events"][match.referee3] = [];
                }
                dividedPerPoule["events"][match.referee3].push([
                  startTime,
                  endTime,
                ]);
              }
            }
          }
          if (match.referee4) {
            if (dividedRefs[match.referee4] === undefined) {
              dividedRefs[match.referee4] = [];
            }
            dividedRefs[match.referee4].push([startTime, endTime]);

            if (this.props.tournament.teamsAsRefs) {
              if (this.props.teamsByKey[match.referee4] !== undefined) {
                if (dividedPerPoule["events"][match.referee4] === undefined) {
                  dividedPerPoule["events"][match.referee4] = [];
                }
                dividedPerPoule["events"][match.referee4].push([
                  startTime,
                  endTime,
                ]);
              }
            }
          }
          if (match.referee5) {
            if (dividedRefs[match.referee5] === undefined) {
              dividedRefs[match.referee5] = [];
            }
            dividedRefs[match.referee5].push([startTime, endTime]);

            if (this.props.tournament.teamsAsRefs) {
              if (this.props.teamsByKey[match.referee5] !== undefined) {
                if (dividedPerPoule["events"][match.referee5] === undefined) {
                  dividedPerPoule["events"][match.referee5] = [];
                }
                dividedPerPoule["events"][match.referee5].push([
                  startTime,
                  endTime,
                ]);
              }
            }
          }
        }

        matchWithTime["startTime"] = startTime;
        matchWithTime["endTime"] = endTime;
        return matchWithTime;
      });
      matchesPerField[fieldKey] = matchesWithTime;
    });

    let multipleLocations = true;
    if (this.props.sportParksByKey["0"]) {
      multipleLocations = this.props.sportParks.length > 1;
    } else {
      multipleLocations = this.props.sportParks.length > 0;
    }

    if (Object.keys(this.props.tournament.fields || {}).length === 0) {
      return (
        <NoScheduleMessage
          tournament={this.props.tournament}
          selectedSportPark={this.props.selectedSportPark}
          multipleLocations={multipleLocations}
          selectedDay={this.props.day}
          tournamentStatus={this.props.tournamentStatus}
          userStatus={this.props.userStatus}
          user={this.props.user}
          toggleUpgradeDialog={this.props.toggleUpgradeDialog}
        />
      );
    }

    let fields = Object.keys(
      this.props.fieldsTemp
        ? this.props.fieldsTemp
        : this.props.tournament.fields || {}
    )
      .filter((key) => {
        let field = this.props.tournament.fields[key];
        let showField = false;
        if (this.props.selectedSportPark === "0") {
          if (field.sportPark === undefined || field.sportPark === "0") {
            showField = true;
          }
        } else {
          if (field.sportPark === this.props.selectedSportPark) {
            showField = true;
          }
        }
        return showField;
      })
      .sort((aKey, bKey) => {
        let a = this.props.tournament.fields[aKey];
        let b = this.props.tournament.fields[bKey];
        if (a.num > b.num) {
          return 1;
        } else if (a.num < b.num) {
          return -1;
        } else {
          return aKey - bKey;
        }
      });

    return (
      <div
        className={this.props.classes.root}
        style={{
          whiteSpace: "nowrap",
          overflowX: "auto",
          display: "flex",
          alignItems: "flex-start",
          paddingLeft: 2,
          paddingTop: 12,
        }}
      >
        {this.props.poulesLoaded &&
          this.props.resultSpotsLoaded &&
          (fields.length > 0 ? (
            <Droppable
              droppableId="fieldDrop"
              direction="horizontal"
              type="FIELD"
            >
              {(provided, snapshotDrop) => {
                return (
                  <div
                    ref={provided.innerRef}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      paddingLeft: 2,
                    }}
                  >
                    {fields.map((fieldKey, i) => {
                      let field = this.props.tournament.fields[fieldKey];
                      field["id"] = fieldKey;
                      return (
                        <div
                          key={fieldKey + this.props.day}
                          style={{ display: "inline-block" }}
                        >
                          <Draggable
                            draggableId={"field" + fieldKey}
                            index={i}
                            type="FIELD"
                            isDragDisabled={
                              this.props.tournament.scheduleLocked || false
                            }
                          >
                            {(provided, snapshot) => (
                              <div>
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <Field
                                    tournament={this.props.tournament}
                                    divisions={this.props.divisions}
                                    divisionsObject={this.props.divisionsObject}
                                    field={field}
                                    poulesByKey={this.props.poulesByKey}
                                    bracketsByKey={this.props.bracketsByKey}
                                    resultSpotsAll={this.props.resultSpotsAll}
                                    refereesByKey={this.props.refereesByKey}
                                    referees={this.props.referees}
                                    days={this.props.days}
                                    day={day}
                                    matches={matchesPerField[fieldKey]}
                                    dividedPerPoule={dividedPerPoule}
                                    dividedRefs={dividedRefs}
                                    tournamentStatus={
                                      this.props.tournamentStatus
                                    }
                                    toggleFinishedDialog={
                                      this.props.toggleFinishedDialog
                                    }
                                    selectedSportPark={
                                      this.props.selectedSportPark
                                    }
                                    selectedDay={this.props.day}
                                    allMatches={this.props.matches}
                                    divisionColors={this.props.divisionColors}
                                    groupColors={this.props.groupColors}
                                    isDraggingRefereeFromMatch={
                                      this.props.isDraggingRefereeFromMatch
                                    }
                                    isDraggingReferee={
                                      this.props.isDraggingReferee
                                    }
                                    sportParksByKey={this.props.sportParksByKey}
                                    isDraggingRefereeMaxMatchesWish={
                                      this.props.isDraggingRefereeMaxMatchesWish
                                    }
                                    teams={this.props.teams}
                                    teamsByKey={this.props.teamsByKey}
                                    eventOptions={this.props.eventOptions}
                                    userStatus={this.props.userStatus}
                                    user={this.props.user}
                                    toggleUpgradeDialog={
                                      this.props.toggleUpgradeDialog
                                    }
                                  />
                                </div>
                                {provided.placeholder}
                              </div>
                            )}
                          </Draggable>
                        </div>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                );
              }}
            </Droppable>
          ) : (
            <NoScheduleMessage
              tournament={this.props.tournament}
              selectedSportPark={this.props.selectedSportPark}
              multipleLocations={multipleLocations}
              selectedDay={this.props.day}
              tournamentStatus={this.props.tournamentStatus}
              userStatus={this.props.userStatus}
              user={this.props.user}
              toggleUpgradeDialog={this.props.toggleUpgradeDialog}
            />
          ))}

        {fields.length > 0 && (
          <div style={{ display: "inline-block" }}>
            <EditFieldContainer
              tournament={this.props.tournament}
              lastStartTime={
                this.props.tournament.fields[
                  Object.keys(this.props.tournament.fields || {})[
                    Object.keys(this.props.tournament.fields || {}).length - 1
                  ]
                ].startTime
              }
              lastEndTime={
                this.props.tournament.fields[
                  Object.keys(this.props.tournament.fields || {})[
                    Object.keys(this.props.tournament.fields || {}).length - 1
                  ]
                ].endTime || ""
              }
              tournamentStatus={this.props.tournamentStatus}
              toggleFinishedDialog={this.props.toggleFinishedDialog}
              selectedSportPark={this.props.selectedSportPark}
              selectedDay={this.props.day}
              userStatus={this.props.userStatus}
              user={this.props.user}
              toggleUpgradeDialog={this.props.toggleUpgradeDialog}
            />
          </div>
        )}
      </div>
    );
  }
}

FieldsContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(FieldsContainer);
